function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.bella{fill:#afafaf;}.bellb{fill:none;stroke:#afafaf;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}\n"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2700.633 -492.3)"
}, /*#__PURE__*/React.createElement("path", {
  className: "bella",
  d: "M2726.507,561.69c-.516,0-.919.207-.784.788a3.715,3.715,0,0,0,7.233,0c.135-.58-.268-.788-.783-.788Z",
  transform: "translate(-15.774 -44.83)"
}), /*#__PURE__*/React.createElement("line", {
  className: "bellb",
  y2: 0.779,
  transform: "translate(2713.566 493.3)"
}), /*#__PURE__*/React.createElement("line", {
  className: "bellb",
  x2: 23.866,
  transform: "translate(2701.633 513.887)"
}), /*#__PURE__*/React.createElement("path", {
  className: "bellb",
  d: "M2707.977,516.874V507.6a9.748,9.748,0,1,1,19.5,0v9.271",
  transform: "translate(-4.159 -2.986)"
}));

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.866,
    height: 28.215,
    viewBox: "0 0 25.866 28.215",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.9e64e06b.svg";
export { ForwardRef as ReactComponent };